import { Routes, Route } from "react-router-dom";
import { useHostOrg } from "./contexts/HostOrganizationProvider";
import { StorefrontHome } from "./pages/StorefrontHome";
import {
  StoreLoadingScreen,
  StoreNotFoundScreen,
  StoreErrorScreen,
} from "./components/StatusScreens";
import { CartProvider } from "@/modules/ecommerce/contexts/CartContext";

export function App() {
  const { status, reload } = useHostOrg();

  if (status.kind === "loading") return <StoreLoadingScreen />;
  if (status.kind === "not-found")
    return <StoreNotFoundScreen host={status.host} />;
  if (status.kind === "error")
    return <StoreErrorScreen message={status.message} onRetry={reload} />;

  // Status is "ok" — wire the cart to the resolved org and route.
  // Passing `row` explicitly into the home page (rather than re-reading
  // the context inside it) keeps StorefrontHome's hook order stable
  // across the loading → ok transition.
  const row = status.row;
  // TODO(storefront-v2): when /cart, /checkout, /product/:slug land,
  // wire each route explicitly here. Until then the catch-all renders
  // the "page not found" variant of the home screen so the visitor
  // still sees the catalogue rather than a blank screen.
  return (
    <CartProvider organizationId={row.organization_id}>
      <Routes>
        <Route path="/" element={<StorefrontHome row={row} />} />
        <Route path="*" element={<StorefrontHome row={row} notFound />} />
      </Routes>
    </CartProvider>
  );
}
